export default __webpack_public_path__ + "static/media/a18.13d5445d.webp";